<template>
    <div v-if="loading" class="flex items-center justify-center w-full p-20">
        <progress-bar
            class="w-[50vw] lg:w-[25vw]"
            mode="indeterminate"
            style="height: 2px"
        />
    </div>
    <div v-else>
        <accordion>
            <accordion-panel as="div" :value="faq.id" v-for="faq in faqs">
                <accordion-header as="button">
                    <h5 class="!font-extrabold">
                        {{ faq.question }}
                    </h5>
                </accordion-header>

                <accordion-content as="div">
                    <div v-html="faq.answer" />
                </accordion-content>
            </accordion-panel>
        </accordion>
    </div>
</template>

<script setup lang="ts">
import {
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    ProgressBar,
} from "primevue";
import { useApiProxy } from "@/Hook/useProxy";
import { onMounted, ref } from "vue";
import { Faq } from "@/types";

const { faq_group_id, ssrData } = defineProps<{
    faq_group_id: number;
    // Server-resolved faqs, injected by ShortcodeResolver for the `[faqs ...]`
    // shortcode so they render during SSR.
    ssrData?: { faqs?: Faq[] };
}>();

const { request, loading } = useApiProxy();

const faqs = ref<Faq[] | undefined>(ssrData?.faqs);

onMounted(function () {
    // Server already resolved the faqs for this shortcode — reuse them.
    if (ssrData?.faqs) return;

    request(route("get.faqs", { faq_group_id }), {}, true)
        .then(function (_faqs: Faq[]) {
            faqs.value = _faqs;
        })
        .catch(console.error);
});
</script>

<style lang="scss" scoped></style>
